var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-icon-button',{attrs:{"title":_vm.title,"icon":_vm.icon},on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"mouseleave":_vm.onMouseLeave}})}
var staticRenderFns = []

export { render, staticRenderFns }